module.exports = __webpack_public_path__ + "static/media/gds_gray@2x.a5292333.png";